//巴西葡萄牙语
export default {
  Login: {
    Title: "Faça login na sua conta",
    describe: "Por favor, faça login ou crie uma conta para começar.",
    Google: "Continuar com o Google",
    Apple: "Continuar com o Apple",
    or: "OU",
    Emailplaceholder: "Endereço de e-mail",
    Passwordplaceholder: "Senha",
    Login: "Entrar",
    forgot: "Esqueceu a senha?",
    notAccount: "Não tem uma conta Fineshare?",
    Signup: "Cadastrar-se",
    InvalidEmail: "Formato de e-mail inválido.",
    InvalidPassword: "A senha deve ter pelo menos 6 caracteres.",
    loading: "Carregando..",
    login: "entrar",
    errorText:
      "Falha no login, por favor, verifique seu nome de usuário e senha",
  },
  signup: {
    Title: "Crie sua conta",
    describe: "Crie sua conta Fineshare em segundos.",
    Google: "Cadastrar-se com o Google",
    Apple: "Cadastrar-se com o Apple",
    or: "OU",
    Emailplaceholder: "Digite o endereço de e-mail",
    Passwordplaceholder: "Digite uma senha de 6 dígitos",
    Already: "Já tem uma conta?",
    Login: "Entrar",
    By: "Ao criar uma conta, concordo que li e aceitei a",
    Privacy: "Política de Privacidade",
    Terms: "Termos de Uso.",
    and: "e",
    signupText: "Criar sua conta",
    InvalidEmail: "Formato de e-mail inválido.",
    InvalidPassword: "A senha deve ter pelo menos 6 caracteres.",
    loading: "Carregando..",
    passwordError: "O endereço de e-mail já foi registrado",
    again:
      "Você está fazendo muitas tentativas, por favor, tente novamente mais tarde",
    Registration: "Falha no registro, por favor, verifique seu e-mail e senha.",
    hasRegistered: "O endereço de e-mail já foi registrado",
    Title2: "Crie sua conta Fineshare",
  },
  Home: {
    Welcome: "Bem-vindo ao Centro de Contas Fineshare",
    Hi: "Olá,",
    Order: "Meus Pedidos",
    orders: "Veja nossos pedidos de compra",
    Learn: "Saiba mais",
    Product: "Gerenciar Produtos",
    products: "Veja meus produtos comprados",
    Setting: "Configurações de Conta",
    Settings: "Detalhes da conta e altere sua senha",
    account: "Aproveite ao máximo sua conta",
    FineCam: "FineCam",
    FineCams: "Crie e compartilhe seus vídeos inspiradores em qualquer lugar",
    FineVoice: "FineVoice",
    FineVoices: "Crie narrações com suas vozes favoritas, do seu jeito",
    VoiceTrans: "VoiceTrans",
    VoiceTranss: "Transforme sua voz, transmita suas emoções",
    Singify: "Singify",
    Singifys: "Crie covers de IA com as vozes que você deseja",
  },
  success: {
    Congratulations: "Parabéns!",
    successfully: "Sua conta Fineshare foi criada com sucesso.",
  },
  successapp: {
    Successful: "Login bem-sucedido!",
    successfully1:
      "Você fez login com sucesso na sua conta Fineshare e agora pode começar a usar o aplicativo.",
    successfully2:
      "Você fez login com sucesso na sua conta Fineshare. Agora pode fechar esta janela e começar a usar o aplicativo.",
    Go: "Ir para o Centro de Usuários Fineshare",
  },
  forgot: {
    ForgotPas: "Esqueceu a senha?",
    Enter1: "Digite o e-mail para redefinir a senha",
    Enter2:
      "Digite seu endereço de e-mail e enviaremos um link para redefinir sua senha.",
    exmple: "nome@exemplo.com",
    Back: "Voltar ao login",
    submitText: "Enviar",
    errorText: "Por favor, insira seu endereço de e-mail",
    loading: "carregando...",
    sent: "Enviamos um e-mail para o seu endereço de e-mail",
    notExist: "Seu e-mail não existe, por favor, verifique seu e-mail",
    Reset: "Falha na redefinição, por favor, verifique seu e-mail",
  },
  account: {
    Settings: "Configurações de Conta",
    Change: "Altere seus detalhes de conta, senhas e mais.",
    Personal: "Informações Pessoais",
    email: "E-mail:",
    Name: "Nome de Usuário:",
    Edit: "Editar",
    title: "Alterar nome de usuário",
    message: "O nome inserido não pode estar vazio.",
    placeholder: "Por favor, insira seu nome de usuário",
    Reset: "Redefinir Senha",
    Resets: "Você pode redefinir sua senha, insira 6 ou mais números e senha",
    ResetPas: "Redefinir Senha",
    Delete: "Excluir Conta",
    Deletes:
      "Isso excluirá permanentemente sua conta e todos os dados relacionados, e você não poderá reativar essa conta.",
    sure: "Tem certeza de que deseja excluir sua conta Fineshare?",
    sures:
      "Depois que sua conta for excluída, todos os seus dados na Fineshare serão removidos permanentemente. Para prosseguir com a exclusão da conta, enviamos um código de verificação para você. Insira o código e clique em Confirmar.",
    Deletebtn: "Excluir",
    Deleteplaceholder: "Por favor, insira o código de verificação de 6 dígitos",
  },
  order: {
    Order: "Meus Pedidos",
    history: "Seu histórico de pedidos foi registrado nesta página",
    dont: "Você ainda não tem um produto",
    Buy: "Compre agora para obter mais otimização, clique no botão abaixo para obter agora",
    BuyBtn: "Compre Agora",
    OrderId: "ID do Pedido:",
    Price: "Preço:",
    Date: "Data do Pedido:",
  },
  Product: {
    Product: "Meu Produto",
    products: "Os produtos registrados na sua conta",
    dont: "Você ainda não tem um produto",
    Management: "Gerenciar Dispositivos >",
  },
  redeem: {
    Redeem: "Resgatar Membro",
    products: "Aqui você pode resgatar produtos Fineshare",
    Please: "Por favor, insira seu código de resgaste",
    placeholder: "Código de resgaste",
    Submit: "Enviar",
    Notes: "Notas:",
    Notes1: "1.Formato do código de resgaste: XXXXX;",
    Notes2:
      "2.Para visualizar seus produtos resgatados, clique no menu 'Produto'.",
    Successfully: "Resgatado com sucesso",
    Follow: "Siga os passos abaixo para começar a usar o VoiceTrans:",
    step1: "1. Baixe e instale o Fineshare VoiceTrans.",
    step2: "2. Abra o VoiceTrans e vá para ",
    Account: "Conta",
    step3: "3. Insira seu e-mail e senha para acessar sua conta Fineshare.",
    Tips: "Dicas: Para melhor utilização, leia o ",
    guide: "guia",
    Redemption: "Falha no Resgate",
    redeemed:
      "O código de resgaste já foi utilizado. Por favor, abra o software e faça login novamente para começar a usá-lo.",
    Failed: "Falha no resgate",
    check: "Por favor, verifique seu código de resgaste.",
  },
  details: {
    Product: "Meu Produto",
    products: "Todos os produtos que você comprou estão nesta página",
    Back: "Voltar à lista",
    Name: "Nome do Dispositivo",
    system: "Sistema do Dispositivo",
    status: "Status do Dispositivo",
    Operation: "Operação",
    Delete: "Excluir",
    contact:
      "A remoção direta não é suportada no momento. Se precisar remover o dispositivo, entre em contato conosco em ",
  },
  nav: {
    Home: "Início",
    Account: "Conta",
    Order: "Pedido",
    Product: "Produto",
    Redeem: "Resgatar",
    Help: "Central de Ajuda",
  },
  auth: {
    Authorization: "Autorização bem-sucedida!",
    wait: "Voltando para o aplicativo, por favor, aguarde...",
  },
  notfound: {
    Not: "Página Não Encontrada",
    Unfortunately:
      "Infelizmente, a página que você está procurando não existe ou há um erro no link inserido.",
    Home: "Ir para a página inicial",
  },
  topuser: {
    Settings: "Configurações da Conta",
    language: "Idioma",
    Logout: "Sair",
  },
  loginweb: {
    Conversion: "A conversão está prestes a começar",
    currently: "Atualmente, há ",
    people: " pessoas na fila!",
    Please:
      "Por favor, faça login, e enviaremos os resultados para o seu e-mail assim que a conversão for concluída.",
    dont: "Não quero fazer login",
  },
  mobilelogin: {
    Welcome: "Bem-vindo ao Fineshare! Por favor, faça login para começar.",
  },
  reset: {
    Reset: "Redefinir uma nova senha",
    Password:
      "A senha deve ter pelo menos 6 caracteres, contendo pelo menos 1 letra e 1 número.",
    password: "Digite sua nova senha",
    Back: "Voltar ao login",
    Congratulations: "Parabéns!",
    successfully:
      "Senha redefinida com sucesso, comece a fazer login imediatamente",
    Login: "Login",
    Please: "Digite 6 dígitos e letras",
    failed:
      "Falha na redefinição de senha, clique no link de redefinição na caixa de entrada",
  },
  verification: {
    verification: "Digite o código de verificação",
    haveverification: "Enviamos um código de verificação para ",
    Please:
      ". Por favor, insira o código de verificação que você recebeu abaixo:",
    Enter: "Digite o código de verificação de 6 dígitos",
    Resend: "Reenviar código de verificação",
    Wait: "Aguarde ",
    again: " segundos e envie novamente",
    Verify: "Verificar",
    error: "Erro no código de verificação",
    verificationcode: "Por favor, insira o código de verificação",
  },
};
